import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { zustandPersistStorage } from '../appState/zustandPersistStorage'
import type { AppLocale } from '../i18n/types'

type LocaleState = {
  locale: AppLocale
  setLocale: (locale: AppLocale) => void
  toggleLocale: () => void
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set, get) => ({
      locale: 'en',
      setLocale: (locale) => set({ locale }),
      toggleLocale: () => set({ locale: get().locale === 'en' ? 'ar' : 'en' }),
    }),
    {
      name: 'rfid-re-locale',
      storage: createJSONStorage(() => zustandPersistStorage),
    }
  )
)
